module.exports = __webpack_public_path__ + "img/pitching8.a526bd37.png";